import { SelecionarTodosService } from '../../service/selecionar-todos.service';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { MatOption, ThemePalette } from '@angular/material/core';
import { AlertService } from './../../service/alert.service';
import { FormControl, FormArray, Validators } from '@angular/forms';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Grupos } from './../../model/grupos.model';
import { GruposService } from './../../service/grupos.service';
import { UsuariosService } from './../../service/usuarios.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from 'src/app/model/user.model';
import { Cliente } from 'src/app/model/cliente.model';
import { ClientesService } from 'src/app/service/clientes.service';
import { MatSelect } from '@angular/material/select';

export interface DialogData {
  usuario: User
}

@Component({
  selector: 'app-atualizar-usuario',
  templateUrl: './atualizar-usuario.component.html',
  styleUrls: ['./atualizar-usuario.component.css']
})
export class AtualizarUsuarioComponent implements OnInit {
  formUsuario!: FormGroup;
  clientes!: Cliente[];
  grupos!: Grupos[];
  public gruposDoUsuario: string[] = [];
  public clientesDoUsuario: string[] = [];
  validacaoGrupo = false;
  validacaoCliente = false;
  flagParaValidacaoGrupo = 0;
  flagParaValidacaoCliente = 0;
  usuario: User = {
    vc_nome: '',
    vc_login: '',
    vc_senha: '',
    bl_status: 1,
  }
  public edited = false;
  load = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;

  @ViewChild('opcaoTodosClientes') opcaoTodosClientes!: MatOption;
  @ViewChild('selectClientes') selectClientes!: MatSelect;

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private service: UsuariosService,
    private activatedRoute: ActivatedRoute,
    private serviceGrupos: GruposService,
    private serviceClientes: ClientesService,
    private alertService: AlertService,
    public selecionarService: SelecionarTodosService
  ) {
    this.formUsuario = this.formBuilder.group({
      sr_id: this.activatedRoute.snapshot.paramMap.get('sr_id')!,
      vc_nome: new FormControl('', [Validators.required]),
      vc_login: new FormControl('', [Validators.email, Validators.required]),
      vc_telefone: new FormControl(''),
      vc_senha: new FormControl(''),
      ar_clientes: new FormControl([], [Validators.required]),
      ar_grupos: new FormControl([], [Validators.required])
    })
  }

  ngOnInit(): void {
    this.usuario.sr_id = this.activatedRoute.snapshot.paramMap.get('sr_id')!;
    this.listarGrupo();
  }

  listarPorId(): void {
    this.service.listarPorIdService(this.usuario.sr_id).subscribe(resp => {
      if (resp == null) {
        this.alertService.error('Não é possível editar usuário')
        this.cancel()
      }
      this.usuario = resp;
      var grupos = resp.ar_grupos;
      this.gruposDoUsuario = grupos;
      var clientes = resp.ar_clientes;
      var telefone = resp.vc_telefone == null ? '55' : resp.vc_telefone
      if (resp.vc_telefone == null) {

      }
      this.clientesDoUsuario = clientes;
      this.formUsuario.get('vc_nome')?.setValue(resp.vc_nome)
      this.formUsuario.get('vc_login')?.setValue(resp.vc_login)
      this.formUsuario.get('vc_senha')?.setValue(resp.vc_senha)
      this.formUsuario.get('vc_telefone')?.setValue(telefone)
      this.formUsuario.get('ar_clientes')?.setValue(resp.ar_clientes)
      this.formUsuario.get('ar_grupos')?.setValue(resp.ar_grupos)
      this.selecionarService.verificarSelecionarTodos(this.formUsuario, 'ar_clientes', this.opcaoTodosClientes, this.clientes)

      this.load = false
    }, erro => {
      this.load = false
    })
  }

  atualizar() {
    this.load = true
    if (this.opcaoTodosClientes.selected) {
      this.formUsuario.value.ar_clientes = this.formUsuario.value.ar_clientes.filter((cliente: any) => cliente !== undefined);
    }
    this.service.atualizarService(this.formUsuario.value).subscribe(resp => {
      this.load = false
      this.alertService.success();
      this.router.navigate(['configuracao/usuarios']);
    }, error => {
      this.load = false
      if (error == '{"error":"Solicitação inválida"}') {
        this.alertService.error('Preencha todos os campos.');
      }
    })
  }

  onCheckboxChangeCliente(e: any) {

    const clientes: FormArray = this.formUsuario.get('ar_clientes') as FormArray;
    if (e.target.checked) {
      clientes.push(new FormControl(parseInt(e.target.value)));
    } else {
      this.clientesDoUsuario.forEach(function (item, index, object) {
        if (e.target.value == item) {
          object.splice(index, 1)
        }
      })
    }

  }

  onCheckboxChangeGrupo(e: any) {
    const grupos: FormArray = this.formUsuario.get('ar_grupos') as FormArray;
    if (e.target.checked) {
      grupos.push(new FormControl(parseInt(e.target.value)));
    } else {
      this.gruposDoUsuario.forEach(function (item, index, object) {
        if (e.target.value == item) {
          object.splice(index, 1)
        }
      })
    }

  }

  checarGrupo(id: any) {
    this.flagParaValidacaoGrupo = 0;
    this.gruposDoUsuario.forEach(element => {
      if (this.flagParaValidacaoGrupo == 0) {
        if (id == element) {
          this.validacaoGrupo = true;
          this.flagParaValidacaoGrupo++;
        } else {
          this.validacaoGrupo = false;
        }
      }
    });
    if (this.validacaoGrupo) {
      return true;
    } else {
      return false;
    }
  }

  checarCliente(id: any) {
    this.flagParaValidacaoCliente = 0;
    this.clientesDoUsuario.forEach(element => {
      if (this.flagParaValidacaoCliente == 0) {
        if (id == element) {
          this.validacaoCliente = true;
          this.flagParaValidacaoCliente++
        } else {
          this.validacaoCliente = false
        }
      }
    });
    if (this.validacaoCliente) {
      return true;
    } else {
      return false;
    }
  }

  listarCliente(): void {
    this.serviceClientes.listarServiceClientes().subscribe(resp => {
      this.clientes = resp;
      this.listarPorId();
    }, erro => {
    })
  }

  listarGrupo(): void {
    this.serviceGrupos.listarService().subscribe(resp => {
      this.grupos = resp;
      this.listarCliente();
    }, erro => {
    })
  }

  cancel() {
    this.router.navigate(['configuracao/usuarios']);
  }

  onInputChange() {
    if (this.formUsuario.get('vc_telefone')?.value.length < 2) {
      this.formUsuario.get('vc_telefone')?.setValue(this.formUsuario.get('vc_telefone')?.value.padEnd(2, '55'));
    }
  }
}
